import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, watch, onMounted } from "vue";
import {
  UsuarioFastDTO,
  UsuarioInscripcionTorneoDTO,
} from "@/interfaces/Usuario";
import { getUsuariosByTorneo } from "@/services/UsuariosService";
import {
  RequestUpdatePairingTorneoDTO,
  UpdatePairingTorneoDTO,
} from "@/interfaces/Live";
import ModalSuccess from "../Commons/ModalSuccess.vue";
import ModalError from "../Commons/ModalError.vue";
import { useRoute } from "vue-router";
import { updatePairingTorneoAsync } from "@/services/PartidaTorneoService";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalEditarPairing',
  props: {
    isVisible: { type: Boolean },
    partida: {},
    idTorneo: {}
  },
  emits: ["confirm", "cerrar"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isModalPairingVisible = ref<boolean>(props.isVisible);
const pairingEditado = ref<UpdatePairingTorneoDTO>({
  nick1: props.partida.nick1,
  nick2: props.partida.nick2,
  idPartidaTorneo: props.partida.idPartidaTorneo,
  idTorneo: props.partida.idTorneo,
  idUsuario1: props.partida.idUsuario1,
  idUsuario2: props.partida.idUsuario2,
});
const isFormValid = ref<boolean>(false);
const jugadores = ref<UsuarioInscripcionTorneoDTO[]>();
const isGenerating = ref<boolean>(false);
const showErrorModal = ref<boolean>(false);
const showSuccessModal = ref<boolean>(false);
const route = useRoute();
const idTorneo = ref<number>(parseInt(route.params.idTorneo.toString()));

// Función para cerrar el modal
const cerrarModal = () => {
  emit("cerrar");
};

// Monitorea cambios en la visibilidad del modal
watch(
  () => props.isVisible,
  newVal => {
    isModalPairingVisible.value = newVal;
  }
);

watch(
  () => props.partida,
  newPartida => {
    pairingEditado.value.idUsuario1 = newPartida.idUsuario1;
    pairingEditado.value.idUsuario2 = newPartida.idUsuario2;
  },
  { immediate: true }
);

// Reglas de validación
const rules = {
  required: (value: unknown) =>
    (value !== null && value !== undefined && value !== "") ||
    "Este campo es obligatorio",
};

const changeJugador = async () => {
  try {
    isGenerating.value = true;

    let idUsuario1 = pairingEditado.value.idUsuario1;
    let idUsuario2 = pairingEditado.value.idUsuario2;

    if (typeof idUsuario1 === "object") {
      idUsuario1 = idUsuario1.idUsuario;
    }

    if (typeof idUsuario2 === "object") {
      idUsuario2 = idUsuario2.idUsuario;
    }

    const body: RequestUpdatePairingTorneoDTO = {
      idPartidaTorneo: props.partida.idPartidaTorneo,
      idUsuario1: idUsuario1 as number,
      idUsuario2: idUsuario2 as number,
    };

    const response = await updatePairingTorneoAsync(body);

    if (response === null || response === undefined) {
      throw new Error("No se pudo modificar el pairing");
    }

    showSuccessModal.value = true;
    emit("confirm", response);
  } catch (error) {
    console.error(error);
    showErrorModal.value = true;
  } finally {
    isGenerating.value = false;
    cerrarModal();
  }
};

onMounted(async () => {
  if (!idTorneo.value) return;
  try {
    const responseJugadores = await getUsuariosByTorneo(idTorneo.value);
    jugadores.value = responseJugadores.data;

    jugadores.value = responseJugadores.data.map((jugador: UsuarioFastDTO) => ({
      idUsuario: jugador.idUsuario,
      nick: jugador.nick,
    }));
  } catch (error) {
    console.error("Error al obtener la información del torneo:", error);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_dialog, {
      modelValue: isModalPairingVisible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isModalPairingVisible).value = $event)),
      "max-width": "400"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode(" Editar emparejamiento ")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, {
                  ref: "form",
                  modelValue: isFormValid.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isFormValid).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_combobox, {
                      label: "Selecciona el nuevo jugador 1",
                      modelValue: pairingEditado.value.idUsuario1,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pairingEditado.value.idUsuario1) = $event)),
                      items: jugadores.value,
                      "item-title": "nick",
                      "item-value": "idUsuario",
                      rules: [rules.required]
                    }, null, 8, ["modelValue", "items", "rules"]),
                    _createVNode(_component_v_combobox, {
                      label: "Selecciona el nuevo jugador 2",
                      modelValue: pairingEditado.value.idUsuario2,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((pairingEditado.value.idUsuario2) = $event)),
                      items: jugadores.value,
                      "item-title": "nick",
                      "item-value": "idUsuario",
                      rules: [rules.required]
                    }, null, 8, ["modelValue", "items", "rules"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  justify: "center",
                  class: "my-4 ga-5"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      variant: "tonal",
                      color: "primary",
                      onClick: _cache[3] || (_cache[3] = () => changeJugador()),
                      large: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Modificar emparejamiento ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      small: "",
                      variant: "tonal",
                      color: "secondary",
                      onClick: cerrarModal
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Cancelar ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: isGenerating.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((isGenerating).value = $event)),
      "hide-overlay": "",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "progress-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary",
              size: "70"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModal.value,
      message: "Emparejamiento modificado correctamente.",
      "onUpdate:isVisible": _cache[6] || (_cache[6] = ($event: any) => (showSuccessModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorModal.value,
      message: "No se ha podido modificar el emparejamiento. Contacta con el administrador.",
      "onUpdate:isVisible": _cache[7] || (_cache[7] = ($event: any) => (showErrorModal.value = $event))
    }, null, 8, ["isVisible"])
  ], 64))
}
}

})